import { useState, useEffect } from "react";

// Material Dashboard 2 PRO React contexts
import { useMaterialUIController } from "context";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "../../../components/MDBox";
import MDModal from "../../../components/MDModal";
import MDTypography from "../../../components/MDTypography";
import MDButton from "../../../components/MDButton";

import { getModels, postModel, putModel } from "api/models";

import PropTypes from "prop-types";

/* import { setAllModels } from "../../../redux/reducers/modelsReducer"; */
import { useSelector } from "react-redux";

import ModelInfo from "./ModelInfo";

export default function CreateEditModel({
  models,
  fetchModelsWithFilters,
  model = null,
  edit = false,
}) {
  const [open, setOpen] = useState(false);

  const [modelId, setModelId] = useState("");
  const [modelName, setModelName] = useState("");
  const [supplier, setSupplier] = useState(null);
  const [modelType, setModelType] = useState(null);

  const allSuppliers = useSelector((state) => state.suppliers.allSuppliers);

  useEffect(() => {
    if (edit && model) {
      setModelId(model.model_id);
      setModelName(model.model_name);
      setSupplier(
        allSuppliers.length > 0 &&
          allSuppliers.find((supplier) => supplier.id === model.supplier_id)
      );
      setModelType(model.model_type);
    }
  }, [edit, model]);

  async function createModelAPI() {
    const model = {
      model_name: modelName,
      model_type: modelType,
      supplier_id: supplier ? supplier.id : null,
    };
    await postModel(model);
  }

  async function updateModelAPI() {
    const model = {
      model_name: modelName,
      model_type: modelType,
      supplier_id: supplier ? supplier.id : null,
    };
    await putModel(model, modelId);
  }

  function resetData() {
    setModelId("");
    setModelName("");
    setModelType(null);
    setSupplier(null);
  }

  useEffect(() => {
    fetchModelsWithFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function submit() {
    if (edit) {
      await updateModelAPI();
      await fetchModelsWithFilters();
    } else {
      await createModelAPI();
      await fetchModelsWithFilters();
      resetData();
    }
    setStep(0);
    setOpen(false);
  }

  async function cancel() {
    if (edit) {
      await fetchModelsWithFilters();
    } else {
      resetData();
    }
    setStep(0);
    setOpen(false);
  }

  const [step, setStep] = useState(0);
  const steps = ["Information du fournisseur"];
  const isLastStep = step === steps.length - 1;

  const next = () => setStep(step + 1);
  const previous = () => setStep(step - 1);

  function getStepContent(stepIndex) {
    switch (stepIndex) {
      case 0:
        return (
          <ModelInfo
            modelName={modelName}
            setModelName={setModelName}
            modelType={modelType}
            setModelType={setModelType}
            supplier={supplier}
            setSupplier={setSupplier}
          />
        );
      default:
        return null;
    }
  }

  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  return (
    <>
      {edit ? (
        <MDButton
          variant="contained"
          size="small"
          onClick={() => setOpen(true)}
          color={darkMode ? "white" : "dark"}
          sx={{
            width: 170,
            padding: "6px 0 !important",
            height: 40,
            color: !darkMode ? "white" : "#1A2035",
            boxShadow:
              darkMode &&
              "0rem 0.1875rem 0.1875rem 0rem rgba(255, 255, 255, 0.15), 0rem 0.1875rem 0.0625rem -0.125rem rgba(255, 255, 255, 0.2), 0rem 0.0625rem 0.3125rem 0rem rgba(255, 255, 255, 0.15)",
            "&:hover": {
              boxShadow:
                darkMode &&
                "0rem 0.875rem 1.625rem -0.75rem rgba(255, 255, 255, 0.4), 0rem 0.25rem 1.4375rem 0rem rgba(255, 255, 255, 0.15), 0rem 0.5rem 0.625rem -0.3125rem rgba(255, 255, 255, 0.2)",
            },
          }}
        >
          Gérer le modèle
        </MDButton>
      ) : (
        <MDButton
          variant="contained"
          sx={{
            height: 53.13,
            width: "100%",
            color: !darkMode ? "white" : "#1A2035",
            boxShadow:
              darkMode &&
              "0rem 0.1875rem 0.1875rem 0rem rgba(255, 255, 255, 0.15), 0rem 0.1875rem 0.0625rem -0.125rem rgba(255, 255, 255, 0.2), 0rem 0.0625rem 0.3125rem 0rem rgba(255, 255, 255, 0.15)",
            "&:hover": {
              boxShadow:
                darkMode &&
                "0rem 0.875rem 1.625rem -0.75rem rgba(255, 255, 255, 0.4), 0rem 0.25rem 1.4375rem 0rem rgba(255, 255, 255, 0.15), 0rem 0.5rem 0.625rem -0.3125rem rgba(255, 255, 255, 0.2)",
            },
          }}
          color={darkMode ? "white" : "dark"}
          size="large"
          onClick={() => setOpen(true)}
        >
          Ajouter un modèle
        </MDButton>
      )}
      <MDModal open={open} onClose={() => setOpen(false)}>
        <MDBox mt={25} mb={9}>
          <Grid container justifyContent="center">
            <Grid item xs={12} lg={8}>
              <Card>
                <MDBox
                  mt={-5}
                  mb={2}
                  mx={2}
                  variant="gradient"
                  sx={{
                    background: darkMode ? "white" : "linear-gradient(195deg, #364c70, #273956)",
                    boxShadow: darkMode ? "0 1px 6px 1px white" : "0 1px 6px 1px #344767",
                  }}
                  borderRadius="lg"
                  textAlign="center"
                >
                  <MDBox mt={2} mb={2}>
                    <MDBox>
                      {edit ? (
                        <MDTypography
                          variant="h3"
                          fontWeight="bold"
                          color={darkMode ? "inherit" : "white"}
                        >
                          Modification du modèle
                        </MDTypography>
                      ) : (
                        <MDTypography
                          variant="h3"
                          fontWeight="bold"
                          color={darkMode ? "inherit" : "white"}
                        >
                          Ajout d'un nouveau modèle
                        </MDTypography>
                      )}
                    </MDBox>
                    <MDTypography
                      variant="h5"
                      fontWeight="regular"
                      color={darkMode ? "inherit" : "white"}
                    >
                      Veuillez entrer les informations relatives au nouveau modèle
                    </MDTypography>
                  </MDBox>
                </MDBox>
                <MDBox p={2}>
                  <MDBox>
                    {getStepContent(step)}
                    <MDBox mt={3} width="100%" display="flex" justifyContent="space-between">
                      {step === 0 ? (
                        <MDBox />
                      ) : (
                        <MDButton variant="gradient" color="warning" onClick={previous}>
                          Précédent
                        </MDButton>
                      )}
                      <MDBox textAlign="right">
                        <Grid container spacing={1.5}>
                          <Grid item>
                            <MDButton
                              variant="gradient"
                              color="warning"
                              onClick={cancel}
                              sx={{ marginRight: 2 }}
                            >
                              Annuler
                            </MDButton>
                          </Grid>
                          <Grid item>
                            <MDButton
                              variant="gradient"
                              color="success"
                              onClick={!isLastStep ? next : submit}
                            >
                              {isLastStep ? "Envoyer" : "Suivant"}
                            </MDButton>
                          </Grid>
                        </Grid>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      </MDModal>
    </>
  );
}

CreateEditModel.propTypes = {
  edit: PropTypes.bool.isRequired,
};
